import { alpha } from '@mui/material/styles'

import { getColors } from '@utils/StylesHelper'

function getColorStyle({ color, theme }) {
  const colors = getColors(theme, color)
  const { lighter, light, main } = colors

  return {
    borderColor: alpha(light, 0.5),
    backgroundColor: lighter,
    '& .MuiAlert-icon': {
      color: main,
    },
  }
}

export default function Alert(theme) {
  const primaryDashed = getColorStyle({ color: 'primary', theme })

  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          fontSize: '0.875rem',
          variants: [
            {
              props: { variant: 'border' },
              style: {
                padding: '10px 16px',
                border: '1px solid',
                ...primaryDashed,
              },
            },
            ...['error', 'success', 'info', 'warning'].flatMap((color) => [
              {
                props: { variant: 'border', severity: color },
                style: getColorStyle({ color, theme }),
              },
              {
                props: { variant: 'border', color },
                style: getColorStyle({ color, theme }),
              },
            ]),
            ...['primary', 'secondary'].map((color) => ({
              props: { variant: 'border', color },
              style: getColorStyle({ color, theme }),
            })),
          ],
        },
        icon: {
          fontSize: '1rem',
        },
        message: {
          padding: 0,
          marginTop: 3,
        },
        filled: {
          color: theme.palette.grey[0],
        },
        action: {
          '& .MuiButton-root': {
            padding: 2,
            height: 'auto',
            fontSize: '0.75rem',
            marginTop: -2,
          },
          '& .MuiIconButton-root': {
            width: 'auto',
            height: 'auto',
            padding: 2,
            marginRight: 6,
            '& .MuiSvgIcon-root': {
              fontSize: '1rem',
            },
          },
        },
      },
    },
  }
}
